"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidPasswordRegex = void 0;
// Exported separately also for convenience of some form validators
exports.isValidPasswordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).{8,128}$/;
/**
 * @deprecated Use testPasswordStrength instead
 * @param password Password to test
 * @returns Whether is strong enough according to Internxt's policy
 */
function isValidPassword(password) {
    return !!password.match(exports.isValidPasswordRegex);
}
exports.default = isValidPassword;
